import { BIBME, CHEGG, CHEGG_NET, CHEGG_SIHP, CITATION_MACHINE, EASYBIB, OWL, Site } from '../types'

interface GDriveConfig {
  apiKey: string
  oauthId: string
  appId: string
  endpoint: string
  scope: string
}

const GDRIVE_ENDPOINT = 'https://www.googleapis.com/drive/v2/files/'
const GDRIVE_SCOPE = 'https://www.googleapis.com/auth/drive'

const gDriveStatic = {
  scope: GDRIVE_SCOPE,
  endpoint: GDRIVE_ENDPOINT,
}

interface GDriveConfigs {
  [site: string]: GDriveConfig
}

const gDrivePgConfigBase = {
  apiKey: 'AIzaSyAcaqzIJh-P3Yq05r7F1vTG3FQyja2WmvM',
  appId: 'wpt-dev-143512',
  oauthId: '793846844721-15dqeae7ggjofrkngihgjinva1pe9lc3.apps.googleusercontent.com',
  ...gDriveStatic,
}

const gDriveProdConfigs: GDriveConfigs = {
  [EASYBIB]: {
    apiKey: 'AIzaSyCyfnvQqKUobdSdEdUBBG6yyTNSlWM8xhU',
    appId: 'easybib-plus',
    oauthId: '738852342504-fitv6mcd55l3h7lh329t1n8ma7le1v3r.apps.googleusercontent.com',
    ...gDriveStatic,
  },
  [BIBME]: {
    apiKey: 'AIzaSyDS5OYMiLLzLUY3vs_zLWxIcErv94xvgMo',
    appId: 'wpt-production',
    oauthId: '782384817026-pgqo32m2p35vfqe753o5dhlfgnn0k1bk.apps.googleusercontent.com',
    ...gDriveStatic,
  },
  [CITATION_MACHINE]: {
    apiKey: 'AIzaSyDc6cmOA_K8VNidURtqv1WyEC1J8jim1P8',
    appId: 'citationmachine-plus',
    oauthId: '938250379325-ffgqkgds53un9ciqf78v8680bt08qv62.apps.googleusercontent.com',
    ...gDriveStatic,
  },
  [CHEGG]: {
    apiKey: 'AIzaSyAvusspDdZ05mMTQkk0XlHRQh5yA8v5n1U',
    appId: 'chegg-writing',
    oauthId: '165598702916-2fam7j1ob2klebpr8fr68a0mftd48gjo.apps.googleusercontent.com',
    ...gDriveStatic,
  },
  [CHEGG_SIHP]: {
    apiKey: 'AIzaSyAvusspDdZ05mMTQkk0XlHRQh5yA8v5n1U',
    appId: 'chegg-writing',
    oauthId: '165598702916-2fam7j1ob2klebpr8fr68a0mftd48gjo.apps.googleusercontent.com',
    ...gDriveStatic,
  },
}

const gtmIds = {
  [EASYBIB]: 'GTM-MS6L4L',
  [BIBME]: 'GTM-T425DXK',
  [CITATION_MACHINE]: 'GTM-PR4ZBX',
  [OWL]: 'GTM-PR4ZBX',
  [CHEGG]: 'GTM-MWT3Q4H',
  [CHEGG_SIHP]: 'GTM-MWT3Q4H',
}

export const tld = {
  [EASYBIB]: 'com',
  [BIBME]: 'org',
  [CITATION_MACHINE]: 'net',
  [OWL]: 'net',
  [CHEGG]: 'com',
  [CHEGG_SIHP]: 'com',
}

const cheggPgDomain = (site: Site, pg?: boolean) => (pg && site === CHEGG ? CHEGG_NET : site)

const basePlaygroundEndpoints = (site: Site) => ({
  cfeUrl: `https://playground.${cheggPgDomain(site, true)}.${tld[site]}`,
  wssUrl: 'wss://wss.wtai.ezbib.com/test',
  uploadUrl: 'https://test.wtai.ezbib.com/upload/api/v1/url',
  wtaiExpressUrl: 'https://test.wtai.ezbib.com/express/api/v1',
})

const baseProdEndpoints = (site: Site) => ({
  cfeUrl: `https://www.${site}.${tld[site]}`,
  wssUrl: 'wss://wss.wtai.easybib.com/prod',
  uploadUrl: 'https://wtai.easybib.com/upload/api/v1/url',
  wtaiExpressUrl: 'https://wtai.easybib.com/express/api/v1',
})

const baseConfig = (site: Site, pg?: boolean) => ({
  baseUrl: `${cheggPgDomain(site, pg)}.${tld[site]}`,
  cookieDomain: `.${cheggPgDomain(site, pg)}.${tld[site]}`,
  gtmID: gtmIds[site],
})

const playgroundConfig = (site: Site) => ({
  ...baseConfig(site, true),
  ...basePlaygroundEndpoints(site),
  gdrive: gDrivePgConfigBase,
})

const prodConfig = (site: Site) => ({
  ...baseConfig(site),
  ...baseProdEndpoints(site),
  gdrive: gDriveProdConfigs[site],
})
export const siteConfig = (site: Site, pg: boolean) => (pg ? playgroundConfig(site) : prodConfig(site))
